<template>
    <v-layout justify="center">
        <v-dialog v-model="dialog" persistent scrollable max-width="600px">
           <v-card v-if="!officesAreSet" >
               <v-card-text>
                    <v-sheet height="80" class="pa-1">
                        <h1 class="title font-weight-light mt-4">Para agregar miembros primero debes configurar sucursales.</h1>
                    </v-sheet>

               </v-card-text>
               <v-card-actions class="text-center">
                   <v-spacer></v-spacer>
                   <v-btn color="secondary" text @click="hide">Cerrar</v-btn>
                   <v-btn color="primary" text :to="{name: 'panel.provider.branches'}">
                       Configurar sucursales
                   </v-btn>
               </v-card-actions>
           </v-card>

            <v-card v-else>
                <v-card-title>
                    <span class="headline">{{user ? 'Editar' : 'Invitar'}} miembro {{me ? ' (Yo)' : ''}}</span>
                </v-card-title>
                <v-card-text class="pt-0">
                    <v-form v-model="valid">
                            <v-row >
                                <v-col cols="12">
                                    <v-text-field
                                            hide-details
                                            filled
                                            :clearable="!isReadOnly"
                                            prepend-inner-icon="email"
                                            @blur="searchEmail"
                                            v-model="email"
                                            :rules="emailRules"
                                            label="E-mail"
                                            :loading="searchingEmail"
                                            :readonly="isReadOnly || me"
                                            :required="!isReadOnly"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                            filled
                                            hide-details
                                            :clearable="!isReadOnly"
                                            prepend-inner-icon="fas fa-user"
                                            v-model="first_name"
                                            :rules="nameRules"
                                            label="Nombre"
                                            :readonly="(isReadOnly && user && user.first_name.length > 0) || me || disableName"
                                            :required="!isReadOnly"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                            filled
                                            hide-details
                                            :clearable="!isReadOnly"
                                            prepend-inner-icon="fas fa-user"
                                            v-model="last_name"
                                            :rules="nameRules"
                                            label="Apellido"
                                            :readonly="(isReadOnly && user && user.last_name.length > 0) || me || disableName"
                                            :required="!isReadOnly"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                            hide-details
                                            :items="rolesItems"
                                            v-model="role"
                                            item-text="name"
                                            item-value="id"
                                            filled
                                            label="Perfil"
                                            dense
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <service-picker
                                            :only-quotable="false"
                                            :value="services"
                                            label="Asociar servicios"
                                            :type="role === 4 ? 'exam' : null"
                                            :disabled="role !== 3 && role !== 4"
                                            multiple
                                            filled
                                            v-on:change="onServicesSelect"
                                            :serviceProviderId="currentProvider.id"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <branch-office-picker filled :value="offices" multiple v-on:change="onOfficesSelect"/>
                                </v-col>
                                <v-col cols="12" v-if="!me">
                                    <v-switch hide-details v-model="isAdminRole" label="Es administrador"
                                              :value="isAdminRole"></v-switch>
                                </v-col>
                                <v-col cols="12" pa-1>
                                  <v-alert outlined color="secondary" :value="disableSpecialists" class="text-center ">
                                    <div class="body-2">Haz alcanzado el límite de cuentas profesionales(especialistas) para tu plan</div>
                                    ¿Necesitas agregar mas?
                                    <br/>
                                    <buy-new-plan-btn/>
                                  </v-alert>
                                </v-col>
                            </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="hide">Cancelar</v-btn>
                    <v-btn color="primary" :disabled="!valid || disabled" :loading="loading" @click="save">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    import BranchOfficePicker from '../../../components/providers/BranchOfficePicker'
    import ServicePicker from '../../../components/providers/ServicePicker'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapGetters, mapMutations} from 'vuex'
    import BuyNewPlanBtn from "../../subscription/BuyNewPlanBtn";

    export default{
        components: {
          BuyNewPlanBtn,
            BranchOfficePicker,
            ServicePicker
        },
        created(){
            this.loadRoles()
        },
        props: {
            user: {
                type: Object
            },
            disableSpecialists:{
              type: Boolean,
              default: false
            }
        },
        data(){
            return {
                loading: false,
                dialog: false,
                valid: false,
                searchingEmail: false,
                disableName: false,
                email: '',
                first_name: '',
                last_name: '',
                role: 2,
                isAdminRole: false,
                offices: [],
                services: [],
                roles: [],
                emailRules: [
                    v => /.+@.+/.test(v) || 'E-mail inválido'
                ],
                nameRules: [
                    v => v && v.length >= 3 || 'Campo requerido'
                ]
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            async searchEmail(){
              const vm = this
              if(!vm.email || vm.searchingEmail) return
              vm.searchingEmail = true
              const response = await ApiUtils.makeGet('user/email', {
                email: vm.email
              })
              vm.searchingEmail = false
              if(!response.ok){
                return vm.disableName = false
              }

              const json = await response.json()
              const {user} = json.result;

              if(!user){
                return vm.disableName = false
              }

              vm.disableName = true
              vm.first_name = user.first_name
              vm.last_name = user.last_name

            },
            async loadRoles(){
                var vm = this
                vm.loadingRoles = true
                const response = await ApiUtils.makeGet(`roles`)
                vm.loadingRoles = false

                if(!response.ok){
                    vm.showSnackBar('Ha ocurrido un error cargando roles')
                    return
                }

                const json = await response.json()
                vm.roles = json.result.roles

            },
            show(){

                var vm = this
                vm.setDefaults()
                vm.dialog = true

            },
            hide(){
                var vm = this
                vm.dialog = false
            },
            onOfficesSelect(offices){
                var vm = this
                vm.offices = offices
            },
            onServicesSelect(services){
                var vm = this
                vm.services = services
            },
            setDefaults(){
                var vm = this
                if(vm.user){
                    vm.email = vm.user.email
                    vm.first_name = vm.user.first_name
                    vm.last_name = vm.user.last_name
                    vm.role = vm.user.role_id
                    vm.isAdminRole = vm.user.is_admin
                    vm.services = vm.user.services.map(service => {
                        return {
                            id: Number(service.id)
                        }
                    })

                    if(vm.user.offices && vm.officesAreSet && vm.user.offices.includes('*')){
                        const allOffices = JSON.parse(JSON.stringify(vm.currentProvider.institution.branch_offices))
                        vm.offices = allOffices.map(office => {
                            return {
                                id: office.id
                            }
                        })
                    }else{
                        vm.offices = vm.user.offices.map(office=> {
                            return {
                                id: Number(office)
                            }
                        })
                    }
                }else{
                   vm.reset()
                }
            },
            reset(){
                var vm = this
                vm.disableName = false
                vm.email = ''
                vm.first_name = ''
                vm.last_name = ''
                vm.role = 2
                vm.isAdminRole = false
                vm.services = []
                vm.offices = []
            },
            async save(){

                var vm = this
                if(vm.loading || !vm.currentProvider) return

                vm.loading = true
                const response = await ApiUtils.makePatch(`provider/${vm.currentProvider.id}/members`, null, {
                    users: [{
                        email: vm.email,
                        first_name: vm.first_name,
                        last_name: vm.last_name,
                        role_id: vm.role,
                        is_admin: vm.isAdminRole ? 1 : 0,
                        offices: vm.offices.map(office => office.id),
                        services: vm.services.map(service => service.id),
                    }]
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar')
                    return
                }

                const json = await response.json()
                vm.$emit('success', json.result.members)
                vm.showSnackBar(vm.user ?'Cambios aplicados correctamente' : 'Se ha enviado invitacion')
                vm.reset()
                vm.hide()

            }
        },
        computed: {
                ...mapState(['currentUser', 'currentProvider']),
            ...mapGetters(['isOwner', 'isAdmin']),
          rolesItems(){
            const vm = this
            if(vm.disableSpecialists){
              return vm.roles.map( rol => {
                return {
                  ...rol,
                  disabled: rol.name === 'Especialista'
                }
              })
            }

            return vm.roles.map(rol => {
              return {
                ...rol,
                disabled: false
              }
            })

          },
            me(){
                const vm = this
                return vm.currentUser && vm.user && vm.user.id === vm.currentUser.id
            },
            isReadOnly(){
                return this.user ? true : false
            },
            disabled(){

                var vm = this
                if((vm.role === 3 || vm.role === 4) && (!vm.services || vm.services.length === 0) ){
                    return true
                }

                if(!vm.offices || vm.offices.length === 0){
                    return true
                }

                return false

            },
            officesAreSet(){
                var vm = this
                return vm.currentProvider
                        && vm.currentProvider.institution
                        && vm.currentProvider.institution.branch_offices
                        && vm.currentProvider.institution.branch_offices.length > 0
            }
        },
        watch:{
            role(val){
                if(val !== 3 && val !== 4){
                    this.services = []
                }
            },
            user(val){
                this.setDefaults()
            },
            officesAreSet(val){
                const vm = this
                if(val){
                    //set owner offices
                }
            }
        }
    }
</script>
